import { Accordion } from "components/DesignSystem/Accordion/Accordion";
import Async from "components/DesignSystem/AsyncComponents/Async";
import { EmptyIcon } from "components/icons/EmptyIcon";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { Link } from "react-router-dom";
import { useGetFilingAndRegistrationCountQuery } from "store/apis/filing";

export const FilingAndRegistrationInfo = () => {
  const entityId = useCurrentEntityId();

  const { data, isLoading, isSuccess, isUninitialized } =
    useGetFilingAndRegistrationCountQuery({ entityId }, { skip: !entityId });
  return (
    <Accordion.Root type="single" defaultValue="DETAILS" collapsible>
      <Accordion.Item
        value="DETAILS"
        className="t-border t-border-sneutral-10 t-rounded-lg t-w-full"
      >
        <Accordion.Trigger>
          <p className="t-text-subtext t-text-text-100 t-m-0">
            Filings <span className="t-lowercase">and</span> Registrations
          </p>{" "}
        </Accordion.Trigger>
        <Accordion.Content>
          <div className="t-py-4 t-pt-2 t-bg-surface">
            <Async.Root
              isEmpty={!Boolean(data?.filing_count || data?.registration_count)}
              isLoading={isLoading}
              isSuccess={isSuccess || isUninitialized}
            >
              <Async.Empty>
                <div className="t-flex t-flex-col t-items-center t-justify-between t-py-5 t-gap-3">
                  <EmptyIcon />
                  <div className="t-flex t-flex-col t-items-center">
                    <span className="t-text-subtext-sm t-text-text-30">
                      No items yet
                    </span>{" "}
                  </div>
                </div>
              </Async.Empty>
              <Async.Success>
                <div className="t-flex t-flex-col t-gap-3">
                  {Boolean(data?.filing_count) && (
                    <Link
                      to={`/sales-tax/state-filings?entity=${entityId}`}
                      className="t-no-underline"
                    >
                      <p className="t-m-0 t-text-purple t-text-subtext ">
                        {data?.filing_count} Filings
                      </p>
                    </Link>
                  )}
                  {Boolean(data?.registration_count) && (
                    <Link
                      to={`/sales-tax/registrations?entity=${entityId}`}
                      className="t-no-underline"
                    >
                      <p className="t-m-0 t-text-purple t-text-subtext">
                        {data?.registration_count} Registrations
                      </p>
                    </Link>
                  )}
                </div>
              </Async.Success>
            </Async.Root>
          </div>
        </Accordion.Content>
      </Accordion.Item>
    </Accordion.Root>
  );
};
